import { MediaImage } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

import getMediaElementByUuid from './getMediaElementByUuid';

const getFilterByUuid = (state: RootState, uuid: number, name: string) =>
  (getMediaElementByUuid(state, uuid) as MediaImage)?.filters?.find((element) => element.name === name)?.value;

export default getFilterByUuid;
